
export class ProgramMessagesNav {
  public static item = {
    title: 'program.tab.messages',
    url: 'messages',
    icon: '<img src="./assets/icons/line-icons/nav/grey/messages.svg" width="23px" height="23px">',
    testId: 'prog-nav-messages',
  };
}
